export default __webpack_public_path__ + "static/media/banner.40106cc7.png";